import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customer.itemsLoading;
export const getItemsSelect = (state:RootState) => state.customer.dropDownItems;